
















































import { Component, Prop, Vue } from "vue-property-decorator";
import NavBar from "../components/NavBar.vue";
import Action from "../store/actionTypes";
import AddressSearch from "../components/AddressSearch.vue";
import LabeledText from "../components/LabeledText.vue";
import { Address } from "../store/user";
import Getter from "../store/getters";

@Component({
  components: {
    NavBar,
    AddressSearch,
    LabeledText
  }
})
export default class Profile extends Vue {
  // @ts-ignore
  private address: Address = { state: {} };
  private updating: boolean = false;
  private address_selected: boolean = false;
  // @ts-ignore
  private address_to_set: Address = { state: {} };
  get selected_address() {
    return this.address_selected;
  }
  set selected_address(value: boolean) {
    if (!value) {
      // @ts-ignore
      this.address_to_set = { state: {} };
      // @ts-ignore
      this.$refs.addressSearchbar.clear();
    }
    this.address_selected = value;
  }
  get addressData() {
    return undefined;
  }
  set addressData(data: any) {
    this.address_to_set = {
      address: `${data.street_number} ${data.route}`,
      city: data.locality,
      // @ts-ignore
      state: { abrv: data.administrative_area_level_1 },
      zip: data.postal_code
    };
  }
  created() {
    this.load_address();
  }
  load_address() {
    this.$store.dispatch(Action.LOAD_ADDRESS).then(response => {
      this.address = this.$store.getters[Getter.MAIL_ADDRESS]();
      console.log(this.address);
    });
  }
  submit_update() {
    this.$store
      .dispatch(Action.SAVE_ADDRESS, this.address_to_set)
      .then(reponse => {
        this.load_address();
        this.selected_address = false;
        this.updating = false;
      });
  }
  placeChanged(place: any) {
    console.log(place);
    this.addressData = place;
    this.selected_address = true;
    console.log(this.address_to_set);
  }
  start_update_address() {
    this.updating = true;
  }
  cancel_update() {
    this.selected_address = false;
    this.updating = false;
  }
}
